import './scss/style.scss';
import './js/hamburger.js';
import './js/stickyNav.js';
import './js/navHighlighting.js';
